import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  form: {
    ordemDeServicoId: '',
    registroDeCampoId: '',
    recursoNome: '',
    recursoId: '',
    observacao: '',
    tarefas: [],
  },
}

const slice = createSlice({
  name: 'ordemDeCorrecaoReducer',
  initialState,
  reducers: {
    setOrdemDeServicoId(state, action) {
      state.form.ordemDeServicoId = action.payload || ''
    },
    setTarefasUnidadeMaterial(state, action) {
      const { tIdx, items } = action.payload
      if (!state.form.tarefas || !state.form.tarefas[tIdx]) return
      state.form.tarefas[tIdx].tarefasUnidadeMaterial = Array.isArray(items) ? items : []
    },
    setRegistroDeCampoId(state, action) {
      state.form.registroDeCampoId = action.payload || ''
    },
    setRecursoNome(state, action) {
      state.form.recursoNome = action.payload || ''
    },
    setRecursoId(state, action) {
      state.form.recursoId = action.payload || ''
    },
    setObservacao(state, action) {
      state.form.observacao = action.payload || ''
    },
    /** Define a data de abertura da ordem (edição retroativa). Valor em ISO ou null para limpar. */
    setDataDeAbertura(state, action) {
      state.form.dataDeAbertura = action.payload ?? null
    },
    /** Define a data de encerramento da ordem (edição retroativa). Valor em ISO ou null para limpar. */
    setDataDeEncerramento(state, action) {
      state.form.dataDeEncerramento = action.payload ?? null
    },
    updateTarefaField(state, action) {
      const { tIdx } = action.payload;
      if (tIdx === undefined || tIdx === null) {
        // Adiciona ao final
        state.form.tarefas = [...(state.form.tarefas || []), action.payload];
      } else {
        // Edita na posição correta
        state.form.tarefas = (state.form.tarefas || []).map((t, idx) =>
          idx === tIdx ? action.payload : t
        );
      }
    },
    removeTarefa(state, action) {
      const index = action.payload
      if (state.form.tarefas && index >= 0 && index < state.form.tarefas.length) {
      state.form.tarefas[index] = {
        ...state.form.tarefas[index],
        removed: true,
      }
      }
    },
     undoRemoveTarefa(state, action) {
      const index = action.payload
      if (state.form.tarefas && index >= 0 && index < state.form.tarefas.length) {
      state.form.tarefas[index] = {
        ...state.form.tarefas[index],
        removed: false,
      }
      }
    },
    addUnidadeMaterial(state, action) {
      const { tIdx, unidadeMaterialId, quantidade, userId, dataDoApontamento, unidadeMaterial } = action.payload
      if (!state.form.tarefas || !state.form.tarefas[tIdx]) return
      const entry = {
        quantidade: typeof quantidade === 'number' ? quantidade : 0,
        userId: userId || 'default',
        dataDoApontamento: dataDoApontamento || new Date().toISOString(),
        unidadeMaterialId: unidadeMaterialId ?? null,
        unidadeMaterial: unidadeMaterial || null,
      }
      const tarefa = state.form.tarefas[tIdx]
      tarefa.tarefasUnidadeMaterial = [...(tarefa.tarefasUnidadeMaterial || []), entry]
    },
    updateUnidadeMaterial(state, action) {
      const { tIdx, tumIdx, field, value } = action.payload
      if (!state.form.tarefas || !state.form.tarefas[tIdx]) return
      const tarefa = state.form.tarefas[tIdx]
      if (!tarefa.tarefasUnidadeMaterial || !tarefa.tarefasUnidadeMaterial[tumIdx]) return
      tarefa.tarefasUnidadeMaterial[tumIdx] = {
        ...tarefa.tarefasUnidadeMaterial[tumIdx],
        [field]: value,
      }
    },
    removeUnidadeMaterial(state, action) {
      const { tIdx, tumIdx } = action.payload
      if (!state.form.tarefas || !state.form.tarefas[tIdx]) return
      const tarefa = state.form.tarefas[tIdx]
      if (!tarefa.tarefasUnidadeMaterial) return
      if(!tumIdx) tarefa.tarefasUnidadeMaterial = []
      const tumToRemove = tarefa.tarefasUnidadeMaterial[tumIdx]
      if(!tumToRemove) return
      if(tumToRemove.id) {
        tarefa.tarefasUnidadeMaterial[tumIdx] = {
          ...tumToRemove,
          removed: true,
        }
      }
      else tarefa.tarefasUnidadeMaterial.splice(tumIdx, 1)
    },
    appendUnidadeMaterialFull(state, action) {
      const { tIdx, item } = action.payload
      if (!state.form.tarefas || !state.form.tarefas[tIdx]) return
      const tarefa = state.form.tarefas[tIdx]
      if (!tarefa.tarefasUnidadeMaterial) tarefa.tarefasUnidadeMaterial = []
      tarefa.tarefasUnidadeMaterial.push(item)
    },
    setUnidadeMaterialAt(state, action) {
      const { tIdx, tumIdx } = action.payload
      if (!state.form.tarefas || !state.form.tarefas[tIdx]) return
      if (!state.form.tarefas[tIdx].tarefasUnidadeMaterial[tumIdx]) return
      state.form.tarefas[tIdx].tarefasUnidadeMaterial[tumIdx] = action.payload
    },
    populateToEdit(state, action) {
      state.form = action.payload || initialState.form
    },
    clear(state) {
      state.form = initialState.form
    },
  },
})

export const {
  setOrdemDeServicoId,
  setRegistroDeCampoId,
  setRecursoNome,
  setRecursoId,
  setObservacao,
  setDataDeAbertura,
  setDataDeEncerramento,
  addTarefa,
  updateTarefaField,
  removeTarefa,
  undoRemoveTarefa,
  addUnidadeMaterial,
  updateUnidadeMaterial,
  removeUnidadeMaterial,
  appendUnidadeMaterialFull,
  setUnidadeMaterialAt,
  setTarefasUnidadeMaterial,
  populateToEdit,
  clear,
} = slice.actions

export default slice.reducer
